/** @format */

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// @ts-ignore
import { Helmet } from "react-helmet";
import { createUseStyles } from "react-jss";
import { ThemeType } from "../styles/theme";
import { agrTosData } from "../constants/TosData";
import { GotoTop } from "../components/Common/GotoTop";
import Zzeung from "../lib/myid-sdk-client-web/lib/index";
import close from "../assets/closeBlack@2x.png";

type ParamTypes = {
   [key: string]: string | undefined;
};

interface Props {
   title: string;
}

const Header: React.FC<Props> = ({ title }) => {
   const useStyles = createUseStyles((theme: ThemeType) => ({
      header: {
         display: "flex",
         justifyContent: "center",
         alignItems: "center",
         position: "fixed",
         top: 0,
         height: "60px",
         width: "100%",
         backgroundColor: "#FFF",
         marginBottom: "30px",
         paddingRight: "20px",
         borderBottom: "1px solid #e1e1e1",
         "& > div": {
            width: "100%",
            minWidth: "calc(100vw - 124px)",
            fontSize: theme.t3,
            textAlign: "center",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontWeight: "500",
         },
         "& > img": {
            width: "22px",
            height: "22px",
            position: "absolute",
            right: "20px",
         },
      },
   }));
   const classes = useStyles();

   const closeWebview = () => {
      Zzeung.CloseWebView();
   };

   return (
      <div className={classes.header}>
         <div>{title}</div>
         <img src={close} onClick={() => closeWebview()} alt="close" />
      </div>
   );
};

const useStyles = createUseStyles((theme: ThemeType) => ({
   wrap: {
      width: "100%",
      marginTop: "90px",
   },
   desc: {
      padding: `0px ${theme.gap}px`,
      "& .divider": {
         width: "100%",
         height: 1,
         marginTop: 26,
         borderBottom: `1px solid ${theme.monoDivider}`,
      },
      "& h1": {
         fontSize: "2.2rem",
         fontWeight: theme.demiLight,
         marginTop: 60,
         marginBottom: 20,
         "&:first-of-type": {
            marginTop: 0,
            marginBottom: 0,
         },
      },
      "& h2": {
         fontSize: "1.8rem",
         paddingTop: 30,
         fontWeight: theme.demiLight,
         "&:first-of-type": {
            paddingTop: 26,
         },
      },
      "& p": {
         color: theme.mono50,
         paddingTop: 10,
         "&.version": {
            paddingTop: 80,
         },
      },
      "& > ol:not(.sub)": {
         margin: 0,
         listStyle: "none",
         paddingLeft: 0,
         paddingTop: 6,
      },
      "& > ol:not(.sub) > li": {
         color: theme.mono50,
         marginTop: 8,
         "&:first-of-type": {
            marginTop: 0,
         },
         "& > ol.sub": {
            marginBottom: "16px",
         },
         "&:last-of-type > ol.sub": {
            marginBottom: "0px",
         },
      },
      "& ol.sub": {
         margin: 0,
         listStyle: "decimal",
         marginTop: 16,
         marginLeft: 14,
         paddingLeft: 14,
      },
      "& ol.sub > li": {
         color: theme.mono50,
         marginTop: 8,
         "&:first-of-type": {
            marginTop: 0,
         },
      },
      "& table": {
         width: "100%",
         color: theme.mono50,
         marginTop: 14,
         marginBottom: 14,
         fontSize: "1.4rem",
         lineHeight: "2.2rem",
         borderCollapse: "collapse",
         "& ol": {
            listStyle: "none",
            padding: 0,
            margin: 0,
         },
         "& tr": {
            "& td": {
               padding: 8,
               verticalAlign: "baseline",
               borderBottom: `1px solid ${theme.monoDim}`,
               borderRight: `1px solid ${theme.monoDim}`,
               "&:first-of-type": {
                  borderLeft: `1px solid ${theme.monoDim}`,
               },
            },
            "&:first-of-type": {
               border: 0,
               background: theme.monoDim,
               color: theme.mono100,
               textAlign: "center",
               "& td": {
                  padding: "8px",
                  borderRight: `1px solid ${theme.mono100}`,
                  "&:last-of-type": {
                     borderRight: `1px solid ${theme.monoDim}`,
                  },
               },
            },
         },
      },
      "& .mg-26": {
         marginBottom: 26,
      },
      "& .numbering": {
         ...theme.text,
         lineHeight: "2.6rem",
         color: theme.mono50,
         marginBottom: 20,
         "&.bold": {
            ...theme.t3,
            fontWeight: theme.medium,
         },
         // "&.str": {
         //   ...theme.t3,
         //   fontWeight: theme.medium,
         //   color: "rgb(39, 109, 255)"
         // },
         "& > div.str": {
            ...theme.t3,
            fontWeight: theme.medium,
            color: "rgb(39, 109, 255)",
         },
         "& > span.blue": {
            color: "rgb(39, 109, 255)",
         },
      },
      "& div.str": {
         color: theme.primaryTxt,
         fontWeight: theme.medium,
      },
      "& div.title-2": {
         ...theme.sText,
         color: theme.mono50,
         marginBottom: 20,
         "& > span.bold": {
            fontWeight: 500,
            color: theme.mono0,
         },
         "& > span.blue": {
            ...theme.t3,
            color: theme.primaryTxt,
         },
      },
   },
}));

const AgrTosDetailPage: React.FC = () => {
   const classes = useStyles();
   const [isScrolling, setIsScrolling] = useState<boolean>(false);
   const { tosId } = useParams<ParamTypes>();
   const item = agrTosData[Number(tosId)];
   let timerId: any = null;
   const isLongDescription = tosId === "0";

   const onScroll = () => {
      if (window.pageYOffset === 0) {
         setIsScrolling(false);
         return;
      }

      setIsScrolling(true);

      if (timerId !== null) {
         clearTimeout(timerId);
      }
      timerId = setTimeout(() => {
         setIsScrolling(false);
      }, 2000);
   };

   const goToTop = () => {
      window.scrollTo(0, 0);
   };

   useEffect(() => {
      window.addEventListener("scroll", onScroll);
      return () => window.removeEventListener("scroll", onScroll);
   }, []);

   return (
      <>
         <div className={classes.wrap}>
            <Header title={item.title} />
            <div
               className={classes.desc}
               dangerouslySetInnerHTML={{
                  __html: item.desc,
               }}
            ></div>
         </div>
         {isLongDescription && (
            <GotoTop goTo={goToTop} isScroll={isScrolling} />
         )}
      </>
   );
};

export default AgrTosDetailPage;
